import { connect } from 'react-redux';
import { BeneficiariesReportPresenter } from 'apps/employer-experience/pages/EmployerDetails/employer-reports/beneficiaries-report.view';
import { mapStateToProps } from 'apps/employer-experience/pages/EmployerDetails/employer-reports/beneficiaries-report.container';
import { EMPLOYER_BENEFICIARIES_REPORT_LIFECYCLE } from './beneficiaries-report.actions';

export const BeneficiariesReport = connect(mapStateToProps, {
  visit: EMPLOYER_BENEFICIARIES_REPORT_LIFECYCLE.visit,
  exit: EMPLOYER_BENEFICIARIES_REPORT_LIFECYCLE.exit,
})(BeneficiariesReportPresenter);
